import { InputField } from './dumb.js';

export default InputField;
